"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { CircleCheck } from "lucide-react";
export default function ElektriciteitsKeuringHoeWerktHet() {
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const steps = [{
    id: 1,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/electrical_inspection_request_step.png",
    title: "Aanvraag indienen",
    features: ["Online formulier invullen", "Telefonisch contact opnemen", "E-mail versturen naar ons team", "Snelle bevestiging binnen 24 uur"]
  }, {
    id: 2,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/electrical_inspection_visit_step.png",
    title: "Inspectiebezoek plannen",
    features: ["Flexibele afspraak op maat", "Professionele en gecertificeerde inspecteur", "Grondige controle van alle installaties", "Duidelijke uitleg tijdens bezoek"]
  }, {
    id: 3,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/electrical_inspection_report_step.png",
    title: "Rapport ontvangen",
    features: ["Officieel keuringsrapport binnen 48 uur", "Digitaal en fysiek beschikbaar", "Duidelijke bevindingen en aanbevelingen", "Conformiteitscertificaat bij goedkeuring"]
  }];
  return <section className="py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={containerRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${containerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-foreground mb-4">
              Elektriciteitskeuring - Hoe werkt het?
            </h2>
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
              In drie eenvoudige stappen naar een veilige elektrische installatie. Ons proces is transparant, efficiënt en volledig op maat van uw behoeften.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {steps.map((step, i) => <div key={step.id} data-index={i} className={`transition-all ease-[var(--ease-smooth)] ${containerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDuration: "var(--duration-medium)",
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full flex flex-col group hover:shadow-medium">
                  <div className="overflow-hidden rounded-t-xl">
                    <img src={step.image} alt={step.title} className="w-full h-56 object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-[1.03]" />
                  </div>
                  <CardHeader>
                    <CardTitle className="text-2xl text-foreground">
                      {step.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <ul className="space-y-3">
                      {step.features.map((feature, idx) => <li key={idx} className="flex items-start gap-2">
                          <CircleCheck className="size-5 text-primary shrink-0 mt-0.5" />
                          <span className="text-muted-foreground">{feature}</span>
                        </li>)}
                    </ul>
                  </CardContent>
                  <CardFooter>
                    <Link to="#" className="w-full">
                      <Button variant="outline" className="w-full transition-all duration-[120ms] ease-in-out hover:scale-[1.04] hover:shadow-lg">
                        Meer info
                      </Button>
                    </Link>
                  </CardFooter>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}